import { put, takeLatest } from "redux-saga/effects";

import { IInitialState } from "@/types/initialState.types";
import {
  setUserJoinLeaveNotification,
  showToast,
} from "@/actions/appStatus.action";
import { getActiveParticipantsAPI } from "@/api/participants.api";
import { GET_ALL_PARTICIPANTS } from "@/constants/ActionTypes";
import { USER_JOIN_NOTIFICATION } from "@/constants/NotificationConstants";
import {
  IGetActiveParticipantsAction,
  IParticipant,
} from "@/types/participants.types";
import { getColorForEmail } from "@/utils/generateColor.utils";
import { EToastType } from "@/components/common/AlertToast/AlertToast.types";
import apiErrorHandler from "@/utils/apiErrorHandler";
import {
  GET_ACTIVE_PARTICIPANTS_API_HTTP_STATUS_CODES,
  GET_ACTIVE_PARTICIPANTS_ERROR_MESSAGE,
} from "@/constants/Participants";
import { call, select } from "./utils.saga";

function* getActiveParticipants({ payload }: IGetActiveParticipantsAction) {
  try {
    const {
      interviewSlug,
      activeParticipantEmails,
      joinedParticipantEmail,
      notifyUser,
    } = payload;
    const participants = yield* select(
      (state: IInitialState) => state.participants,
    );
    const currentUserEmail = yield* select(
      (state: IInitialState) => state.auth.userIdentityData?.email,
    );
    if (!joinedParticipantEmail || !participants[joinedParticipantEmail]) {
      const resp = yield* call(getActiveParticipantsAPI, interviewSlug);
      if (resp.data.participants?.length) {
        resp.data.participants.forEach((participant: IParticipant) => {
          if (!participants[participant.email]) {
            participants[participant.email] = {
              ...participant,
              color: getColorForEmail(participant.email),
              inInterview: participant.email === currentUserEmail,
            };
          }
        });
      }
    }
    if (joinedParticipantEmail && participants[joinedParticipantEmail]) {
      participants[joinedParticipantEmail].inInterview = true;
      const userJoinedNotification = `${participants[joinedParticipantEmail].name} ${USER_JOIN_NOTIFICATION}`;
      if (notifyUser) {
        yield put(setUserJoinLeaveNotification(userJoinedNotification));
      }
    }
    if (activeParticipantEmails?.length) {
      Object.keys(participants).forEach((participantsEmail) => {
        participants[participantsEmail].inInterview =
          activeParticipantEmails.includes(participantsEmail) ||
          currentUserEmail === participantsEmail;
      });
    }
    yield put({
      type: `${GET_ALL_PARTICIPANTS}_SUCCESS`,
      payload: {
        participants,
      },
    });
  } catch (error: unknown) {
    const message = yield* call(
      apiErrorHandler,
      error,
      GET_ACTIVE_PARTICIPANTS_API_HTTP_STATUS_CODES,
      GET_ACTIVE_PARTICIPANTS_ERROR_MESSAGE,
    );
    if (message)
      yield put(
        showToast({
          message,
          type: EToastType.ERROR,
        }),
      );
  }
}

export default function* loadParticipantSaga() {
  yield takeLatest(GET_ALL_PARTICIPANTS, getActiveParticipants);
}
